export const metaFields = [
    {
        name: 'First name',
        field: 'firstname',
        check: 'required',
    },
    {
        name: 'Middle name', 
        field: 'middlename',
        check: 'required'
    },
    {
        name: 'Last name', 
        field: 'lastname',
        check: 'required'
    },
    {
        name: 'DOB',
        field: 'dob',
        check: 'required',
    },
    {
        name: 'ID/ Passport No',
        field: 'nationalid',
        check: 'required',
    },
    {
        name: 'ID/ Passport No',
        field: 'nationalid',
        field2: 'cNationalid',
        check: 'confirmed',
    },
    {
        name: 'ID/ Passport No',
        field: 'nationalid',
        check: 'min',
        value: 4
    },
    {
        name: 'Cellphone',
        field: 'cellphone',
        check: 'required',
    },
    {
        name: 'Cellphone',
        field: 'cellphone',
        field2: 'cCellphone',
        check: 'confirmed',
    },
    {
        name: 'Cellphone',
        field: 'cellphone',
        check: 'min',
        value: 9
    },
    {
        name: 'Gender',
        field: 'genderid',
        check: 'required',
    },
    {
        name: 'Employer',
        field: 'employer',
        check: 'required',
    },
    {
        name: 'Employment Type',
        field: 'employmentstatusid',
        check: 'required',
    },{
        name: 'Occupation',
        field: 'occupation',
        check: 'required',
    },{
        name: 'Residence',
        field: 'residence',
        check: 'required',
    },
    
];
